import GisTreeHierarchy from "components/adhoc/gistreehierarchy";
import GisHierarchyMap from "../components/adhoc/gishierarchymap";

import GisLayersTreeHierarchyProvider from "storage/context/gis-layers-tree-hierarchy-context";

export type ActualNode = {
    id: number;
    folder: string;
};

const GisPageTreeTab = () => {
    return (
        <GisLayersTreeHierarchyProvider>
            <div className="l-gis-page-tree-tab">
                <div className="l-gis-page-tree-tab__container">
                    <div className="l-gis-page-tree-tab__tree">
                        <GisTreeHierarchy />
                    </div>
                    <GisHierarchyMap />
                </div>
            </div>
        </GisLayersTreeHierarchyProvider>
    );
};

export default GisPageTreeTab;
